'use client';

import {ErrorSection} from '@/components/sections/Error.section';
import {useEffect} from 'react';

export default function Error({error}: {error: Error & {digest?: string}; reset: () => void}) {
	useEffect(() => {
		//TODO Log the error to an error reporting service
		console.error(error);
	}, [error]);

	return <ErrorSection status={500} />;
}
